import React from "react";
import { Button } from "antd";
import successImage from "@/assets/images/success-ok.png";
import failedImage from "@/assets/images/audio-failed.png";
import { Trans, useTranslation } from "react-i18next";

import "@/assets/videoCompress.less";

const VideoCompressWorkFinishRender = ({
  submitStatus,
  videoCompressAfter,
  videoCompressObj,
  handleDownload,
  handleSubmitAgain,
  handleGoToEdit,
  handleEditNewOne,
  goBackToWorkPlace,
}) => {
  const { t } = useTranslation(["videoCompress", "common"]);

  return (
    <div className="work-cont-finish">
      {submitStatus === "success" ? (
        <div className="success">
          <h2>
            {t("xx% reduction in size!", { num: (((videoCompressObj.size - videoCompressAfter.size) / videoCompressObj.size) * 100).toFixed(2) })}
          </h2>
          {/* <p>
          Compressed successfully, your file is now
          t()
          <span style={{ textDecoration: "line-through" }}>{(videoCompressObj.size / 1024 / 1024).toFixed(2)}MB </span>
          <span style={{ color: "#8372FF" }}> {(videoCompressAfter.size / 1024 / 1024).toFixed(2)}MB</span>
        </p> */}
          <Trans>
            <div className="sub-title">
              {t("Compressed successfully, your file is now xxMB.", {
                transSupportBasicHtmlNodes: true,
                originalSize: (videoCompressObj.size / 1024 / 1024).toFixed(2),
                compressSize: (videoCompressAfter.size / 1024 / 1024).toFixed(2),
              })}
            </div>
          </Trans>
          <img alt="success" src={successImage} />
          <div className="btn-group">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={goBackToWorkPlace}>
              <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#8372FF" />
              <path d="M36 18L24 30L36 42" stroke="#8372FF" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            </svg>
            <Button type="primary" size="large" onClick={handleDownload}>
              {t("common:Download")}
            </Button>
            <Button type="primary" size="large" ghost onClick={handleGoToEdit}>
              {t("common:Go Edit")}
            </Button>
          </div>
          <span className="new-link" onClick={handleEditNewOne}>
            {t("Compress New")}
          </span>
        </div>
      ) : (
        <div className="failed">
          <h2>{t("Compression Failed")}</h2>
          <img alt="success" src={failedImage} />
          <div className="btn-group">
            <Button type="primary" size="large" onClick={goBackToWorkPlace}>
              {t("common:Try Again")}
            </Button>
            <Button
              type="primary"
              size="large"
              ghost
              onClick={() => {
                window.open(window.location.href);
              }}
            >
              {t("Compress New")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoCompressWorkFinishRender;
